var EventQueue = /** @class */ (function () {
    function EventQueue() {
        this.queuedEvents = [];
    }
    EventQueue.prototype.queueEvent = function (event) {
        this.queuedEvents.push(event);
    };
    EventQueue.prototype.drainQueue = function () {
        return this.queuedEvents.splice(0, this.queuedEvents.length);
    };
    return EventQueue;
}());
export { EventQueue };
//# sourceMappingURL=EventQueue.js.map